import { render, staticRenderFns } from "./ScoreCalcRuleGroup.vue?vue&type=template&id=92a2a950&"
import script from "./ScoreCalcRuleGroup.vue?vue&type=script&lang=js&"
export * from "./ScoreCalcRuleGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports